'use client';

import dynamic from 'next/dynamic';

/**
 * Loads the Change Request widget in the browser only, split into its own
 * chunk so no live site pays for it: only Preview Sites render this loader.
 * SnapDOM and the marking tools load later still, when a Reviewer starts a
 * request.
 */
const ChangeRequestWidgetLoader = dynamic(() => import('./widget'), { ssr: false, loading: () => null });

export default ChangeRequestWidgetLoader;
